import TrackContact from "@/components/TrackContact";
import { PAGE_META } from "@/lib/seo-constants";

export default function CommercialContact() {
    return (
        <TrackContact
            trackKey="commercial"
            meta={PAGE_META.commercialContact}
            headline={
                <>
                    Scoped commercial quotes,
                    <br />
                    <span className="text-brand-coral">done right.</span>
                </>
            }
            subhead="Tell us about your property or portfolio in a few quick steps. We respond within one business day with next steps, COIs, and a free site assessment."
        />
    );
}
